import logUtil from 'utils/log'

export default function getSuperLikedTooltipLabelUtil (props) {
  logUtil('getSuperLikedTooltipLabelUtil').debug('props=', props)
  const {
    memberHasSuperLiked,
    hasBothSuperLiked,
    currentMemberFirstName
  } = props

  if (hasBothSuperLiked) {
    return `Both you and ${currentMemberFirstName} superliked it`
  }

  if (memberHasSuperLiked) {
    return `${currentMemberFirstName} superliked it`
  }

  return 'You superliked it'
}
